<div class="wizard-wrapper glass-wizard">

  <!-- ── HEADER DEL WIZARD ───────────────────────────────────────────── -->
  <div class="wizard-header">
    <button class="wiz-back-btn" (click)="dismiss()" aria-label="Cerrar">
      <ion-icon name="close"></ion-icon>
    </button>

    <!-- Barra de progreso visual -->
    <div class="progress-track">
      <div class="progress-fill" [style.width.%]="(currentStep / totalSteps) * 100"></div>
    </div>

    <span class="step-counter">{{ currentStep }}/{{ totalSteps }}</span>
  </div>

  <!-- ── CONTENIDO POR PASO ─────────────────────────────────────────── -->
  <ion-content class="wizard-content">
    <div class="wizard-body">

      <!-- ══════════ PASO 1 — FOTO (OPCIONAL) ══════════ -->
      <div class="step-panel animate-fade" *ngIf="currentStep === 1">
        <div class="step-header">
          <div class="step-illustration foto">
            <ion-icon name="camera-outline"></ion-icon>
          </div>
          <div class="step-header-text">
            <h2 class="step-question">¿Desea tomar o subir una foto?</h2>
            <p class="step-hint">La foto le permitirá trazar líneas y calcular las medidas visualmente</p>
          </div>
        </div>

        <div class="step-input-area photo-input-area">
          <!-- Botón de seleccionar foto si no hay una -->
          <div *ngIf="!currentMedida.foto" class="photo-pickers-row">
            <button (click)="takePhotoSource('camera')" class="photo-option-btn camera-btn">
              <div class="pob-icon-wrap">
                <ion-icon name="camera"></ion-icon>
              </div>
              <span>Cámara</span>
            </button>
            <button (click)="takePhotoSource('photos')" class="photo-option-btn gallery-btn">
              <div class="pob-icon-wrap">
                <ion-icon name="images"></ion-icon>
              </div>
              <span>Galería</span>
            </button>
          </div>

          <!-- Preview de foto y opciones si ya existe una -->
          <div class="photo-section" *ngIf="currentMedida.foto">
            <div class="photo-card" (click)="manageImage()">
              <img [src]="getPhotoSrc(currentMedida.foto)" />

              <!-- Acciones rápidas flotantes (Ver completa y Recortar) -->
              <div class="photo-quick-actions" (click)="$event.stopPropagation()">
                <button type="button" class="pqa-btn expand" (click)="viewImageFull(false)" title="Ver completa">
                  <ion-icon name="expand-outline"></ion-icon>
                </button>
                <button type="button" class="pqa-btn crop" (click)="viewImageFull(true)" title="Recortar imagen">
                  <ion-icon name="crop-outline"></ion-icon>
                </button>
              </div>

              <!-- Overlay inferior con botón de opciones -->
              <div class="photo-overlay">
                <div class="photo-overlay-glass">
                  <ion-icon name="options-outline"></ion-icon>
                  <div class="photo-overlay-texts">
                    <span class="photo-overlay-title">Opciones de Foto</span>
                    <span class="photo-overlay-hint">Editar líneas, cambiar o eliminar</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ══════════ PASO 2 — DESCRIPCIÓN ══════════ -->
      <div class="step-panel animate-fade" *ngIf="currentStep === 2">
        <div class="step-header">
          <div class="step-illustration descripcion">
            <ion-icon name="document-text-outline"></ion-icon>
          </div>
          <div class="step-header-text">
            <h2 class="step-question">Nombre o descripción</h2>
            <p class="step-hint">Identifique esta medida de forma clara (ej. Muro principal, Ventana, Techo)</p>
          </div>
        </div>

        <div class="step-input-area">
          <div class="glass-input-wrapper">
            <ion-item lines="none" class="custom-item">
              <ion-input [(ngModel)]="currentMedida.descripcion" placeholder="Ej. Muro principal" class="bold-input" mode="ios"></ion-input>
            </ion-item>
          </div>
        </div>
      </div>

      <!-- ══════════ PASO 3 — UNIDAD Y MODALIDAD ══════════ -->
      <div class="step-panel animate-fade" *ngIf="currentStep === 3">
        <div class="step-header">
          <div class="step-illustration unidad">
            <ion-icon name="apps-outline"></ion-icon>
          </div>
          <div class="step-header-text">
            <h2 class="step-question">Modalidad y Unidad</h2>
            <p class="step-hint">Seleccione si registrará medida única o al cuadrado, y elija la unidad</p>
          </div>
        </div>

        <div class="step-input-area">
          <!-- Segment de medidas: Por dimensiones vs Al cuadrado (solo para metros cuadrados) -->
          <div class="step3-segment-wrapper" *ngIf="currentMedida.tipo_medida === 'cuadrada'">
            <label class="step-section-label">Tipo de Medición</label>
            <ion-segment [value]="modoIngreso" mode="ios" class="medida-mode-segment" (ionChange)="onModoIngresoChange($event)">
              <ion-segment-button value="dimensiones">
                <ion-icon name="scan-outline"></ion-icon>
                <ion-label>Por dimensiones</ion-label>
              </ion-segment-button>
              <ion-segment-button value="cuadrado">
                <ion-icon name="calculator-outline"></ion-icon>
                <ion-label>Al cuadrado</ion-label>
              </ion-segment-button>
            </ion-segment>
          </div>

          <!-- Listado de unidades rápidas en rejilla de 3 columnas -->
          <div class="unidades-list-wrapper">
            <label class="step-section-label">Unidad de medida</label>
            <div class="unidades-grid">
              <div *ngFor="let opt of getMedidaOptions()" 
                (click)="currentMedida.unidad = opt.dt2" 
                class="unidad-card-pill"
                [class.active]="currentMedida.unidad === opt.dt2">
                <span class="ucp-name">{{ opt.dt2 }}</span>
                <span class="ucp-status" *ngIf="currentMedida.unidad === opt.dt2">Activo</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ══════════ PASO 4 — CANTIDAD Y MEDIDAS ══════════ -->
      <div class="step-panel animate-fade" *ngIf="currentStep === 4">
        <div class="step-header">
          <div class="step-illustration dimensiones">
            <ion-icon name="resize-outline"></ion-icon>
          </div>
          <div class="step-header-text">
            <h2 class="step-question">Cantidad y Dimensiones</h2>
            <p class="step-hint">Ingrese las magnitudes físicas y la cantidad de elementos</p>
          </div>
        </div>

        <div class="step-input-area dimensiones-container">
          <!-- Botón superior para añadir otra dimensión -->
          <button type="button" class="btn-add-dimension top-add-btn" (click)="addDimension()">
            <ion-icon name="add-circle-outline"></ion-icon>
            <span>+ Agregar otra medida</span>
          </button>

          <div class="dimension-card animate-fade" *ngFor="let dim of dimensionesList; let i = index">
            <div class="dim-card-header">
              <div class="dim-badge">
                <ion-icon name="layers-outline"></ion-icon>
                <span>Medida #{{ dimensionesList.length - i }}</span>
                <span class="dim-mode-tag" *ngIf="currentMedida.tipo_medida === 'cuadrada'">
                  {{ modoIngreso === 'cuadrado' ? ('Al cuadrado (' + currentMedida.unidad + ')') : 'Por dimensiones' }}
                </span>
                <span class="dim-mode-tag" *ngIf="currentMedida.tipo_medida === 'lineal'">
                  Lineal ({{ currentMedida.unidad }})
                </span>
                <span class="dim-mode-tag" *ngIf="currentMedida.tipo_medida === 'unidad'">
                  Por Unidad
                </span>
              </div>
              <button *ngIf="dimensionesList.length > 1" 
                      type="button"
                      class="dim-delete-btn" 
                      (click)="removeDimension(i)" 
                      title="Eliminar medida">
                <ion-icon name="trash-outline"></ion-icon>
              </button>
            </div>

            <div class="dim-card-body">
              <div class="fields-row">
                <!-- Cantidad -->
                <div class="field-col dim-col-cant">
                  <label class="glass-label">Cant.</label>
                  <div class="glass-input-wrapper">
                    <ion-item lines="none">
                      <ion-input type="number" [(ngModel)]="dim.cantidad" placeholder="1" min="1" class="bold-input" mode="ios"></ion-input>
                    </ion-item>
                  </div>
                </div>

                <!-- Si es lineal: Solo Largo -->
                <ng-container *ngIf="currentMedida.tipo_medida === 'lineal'">
                  <div class="field-col">
                    <label class="glass-label">Largo ({{ currentMedida.unidad || 'ml' }})</label>
                    <div class="glass-input-wrapper">
                      <ion-item lines="none">
                        <ion-input type="number" [(ngModel)]="dim.ancho" placeholder="0.00" class="bold-input" mode="ios"></ion-input>
                      </ion-item>
                    </div>
                  </div>
                </ng-container>

                <!-- Si es cuadrada por dimensiones: Ancho y Alto con unidades base (sin el 2) -->
                <ng-container *ngIf="currentMedida.tipo_medida === 'cuadrada' && modoIngreso === 'dimensiones'">
                  <div class="field-col">
                    <label class="glass-label">
                      Ancho ({{ currentMedida.unidad || 'm' }})
                    </label>
                    <div class="glass-input-wrapper">
                      <ion-item lines="none">
                        <ion-input type="number" [(ngModel)]="dim.ancho" placeholder="0.00" class="bold-input" mode="ios"></ion-input>
                      </ion-item>
                    </div>
                  </div>

                  <div class="field-col">
                    <label class="glass-label">Alto ({{ currentMedida.unidad || 'm' }})</label>
                    <div class="glass-input-wrapper">
                      <ion-item lines="none">
                        <ion-input type="number" [(ngModel)]="dim.alto" placeholder="0.00" class="bold-input" mode="ios"></ion-input>
                      </ion-item>
                    </div>
                  </div>
                </ng-container>

                <!-- Si es cuadrada al cuadrado: Total al cuadrado directamente con unidad elevada al 2 -->
                <ng-container *ngIf="currentMedida.tipo_medida === 'cuadrada' && modoIngreso === 'cuadrado'">
                  <div class="field-col">
                    <label class="glass-label">Total al cuadrado ({{ currentMedida.unidad || 'm²' }})</label>
                    <div class="glass-input-wrapper">
                      <ion-item lines="none">
                        <ion-input type="number" [(ngModel)]="dim.ancho" placeholder="0.00" class="bold-input" mode="ios"></ion-input>
                      </ion-item>
                    </div>
                  </div>
                </ng-container>
              </div>

              <!-- Nota opcional por medida -->
              <div class="dim-nota-row">
                <label class="glass-label">Nota (opcional)</label>
                <div class="glass-input-wrapper nota-input-wrapper">
                  <ion-item lines="none">
                    <ion-icon name="create-outline" slot="start" class="nota-icon"></ion-icon>
                    <ion-input [(ngModel)]="dim.comentario" placeholder="Ej. Detalle o referencia específica" class="regular-input" mode="ios"></ion-input>
                  </ion-item>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ══════════ PASO 5 — COMENTARIO ══════════ -->
      <div class="step-panel animate-fade" *ngIf="currentStep === 5">
        <div class="step-header">
          <div class="step-illustration comentario">
            <ion-icon name="chatbox-ellipses-outline"></ion-icon>
          </div>
          <div class="step-header-text">
            <h2 class="step-question">Comentarios o notas</h2>
            <p class="step-hint">Notas adicionales, detalles sobre el material o problemas encontrados</p>
          </div>
        </div>

        <div class="step-input-area">
          <div class="glass-textarea-wrapper">
            <textarea [(ngModel)]="currentMedida.comentario" rows="5" placeholder="Ingrese notas o comentarios sobre la medición..." class="glass-textarea"></textarea>
          </div>
        </div>
      </div>

    </div>
  </ion-content>

  <!-- ── FOOTER DE ACCIONES ──────────────────────────────────────────── -->
  <div class="wizard-footer">

    <!-- Indicadores de paso (dots) en la izquierda -->
    <div class="step-dots">
      <div class="dot" *ngFor="let i of [1,2,3,4,5]" [class.active]="i === currentStep" [class.done]="i < currentStep">
      </div>
    </div>

    <!-- Botones agrupados en la derecha estirándose proporcionalmente -->
    <div class="wiz-actions-group">

      <!-- Atrás -->
      <button
        *ngIf="currentStep > 1"
        (click)="prevStep()"
        class="wiz-prev-btn">
        <ion-icon name="arrow-back-outline"></ion-icon>
        <span>Atrás</span>
      </button>

      <!-- Continuar (pasos 1 a 4) -->
      <button class="wiz-next-btn" *ngIf="currentStep < 5" [disabled]="!canAdvance()" (click)="nextStep()">
        <span>{{ currentStep === 1 && !currentMedida.foto ? 'Saltar Paso' : 'Continuar' }}</span>
        <ion-icon name="arrow-forward-outline"></ion-icon>
      </button>

      <!-- Guardar (paso 5) -->
      <button class="wiz-save-btn" *ngIf="currentStep === 5" [disabled]="isSaving || !canAdvance()" (click)="nextStep()">
        <ion-spinner *ngIf="isSaving" name="crescent"></ion-spinner>
        <ion-icon *ngIf="!isSaving" name="save-outline"></ion-icon>
        <span>{{ isSaving ? 'Guardando...' : 'Guardar' }}</span>
      </button>

    </div>
  </div>

</div>
